import type {DynamicIconSetLoader, DynamicIconGetter} from './types';

export function makeDynamicIconGetter<T extends string = never>(
  loader: DynamicIconSetLoader,
): DynamicIconGetter<T> {
  return (name) => ({
    loader,
    name,
  });
}
